import type { AppStoreState } from "./types";

export const selectCounterValue = (state: AppStoreState) => state.counter.value;
export const selectThemeMode = (state: AppStoreState) => state.ui.themeMode;
export const selectBusyKeys = (state: AppStoreState) => state.ui.busyKeys;
export const selectSelectedRequirementIds = (state: AppStoreState) =>
  state.ui.selectedRequirementIds;
export const selectDomain = (state: AppStoreState) => state.ui.domain;
export const selectAssessmentSidebarIds = (state: AppStoreState) =>
  state.ui.assessmentSidebarIds;
/** Explicit sidebar checkboxes only — do not treat the whole queue as selected when unset. */
export const selectAssessmentSidebarSelectedIds = (state: AppStoreState) =>
  state.ui.assessmentSidebarSelectedIds ?? [];
export const selectAssessmentSidebarAddedAt = (state: AppStoreState) =>
  state.ui.assessmentSidebarAddedAt ?? {};
export const selectAssessmentSidebarVersionOverrides = (state: AppStoreState) =>
  state.ui.assessmentSidebarVersionOverrides ?? {};
export const selectAssessmentSidebarOpen = (state: AppStoreState) =>
  state.ui.assessmentSidebarOpen;
export const selectAssessmentSidebarCollapsed = (state: AppStoreState) =>
  state.ui.assessmentSidebarCollapsed;
export const selectAssessmentSidebarIdsCount = (state: AppStoreState) =>
  state.ui.assessmentSidebarIds.length;
export const selectUserRole = (state: AppStoreState) => state.ui.userRole;
export const selectPrivileges = (state: AppStoreState) => state.ui?.privileges || [];
export const selectPrivilegesLoaded = (state: AppStoreState) => state.ui?.privilegesLoaded || false;

export const selectRegulationsListPagination = (state: AppStoreState) =>
  state.regulationsList.paginationModel;
export const selectRegulationsListMarkets = (state: AppStoreState) =>
  state.regulationsList.selectedMarkets;
export const selectRegulationsListProductTypes = (state: AppStoreState) =>
  state.regulationsList.selectedProductTypes;
export const selectRegulationsListHA = (state: AppStoreState) =>
  state.regulationsList.selectedHA;
export const selectRegulationsListTags = (state: AppStoreState) =>
  state.regulationsList.selectedTags;
export const selectRegulationsListTitle = (state: AppStoreState) =>
  state.regulationsList.selectedTitle;
export const selectRegulationsListFromDateIso = (state: AppStoreState) =>
  state.regulationsList.fromDateIso;
export const selectRegulationsListToDateIso = (state: AppStoreState) =>
  state.regulationsList.toDateIso;
export const selectRegulationsListFavoriteFilter = (state: AppStoreState) =>
  state.regulationsList.favoriteFilter;
export const selectRegulationsListActiveSavedFilterId = (state: AppStoreState) =>
  state.regulationsList.activeSavedFilterId;
export const selectRegulationsListGridColumnFilterModel = (state: AppStoreState) =>
  state.regulationsList.gridColumnFilterModel;
export const selectRegulationsListGridColumnVisibilityModel = (
  state: AppStoreState,
) => state.regulationsList.gridColumnVisibilityModel;
export const selectRegulationsListGridColumnOrderedFields = (
  state: AppStoreState,
) => state.regulationsList.gridColumnOrderedFields;
export const selectRegulationsListGridDensity = (state: AppStoreState) =>
  state.regulationsList.gridDensity;
